import { AsyncHelper, CycleResolutionPopup, SchedulingIssueResolutionPopup } from "@bryntum/gantt/gantt.module";
import { observer } from "./observer";

export class OurSchedulingIssueResolutionPopup extends SchedulingIssueResolutionPopup {
  async onApplyButtonClick() {
    const me = this;

    await super.onApplyButtonClick();
    const interval = setInterval(async () => {
      if (!me.schedulingIssue) {
        clearInterval(interval);
        const { selectedResolutions } = me;
        for (const resolution of selectedResolutions) {
          if (resolution.isRemoveDateConstraintConflictResolution) {
            const { event } = resolution;
            await AsyncHelper.sleep(200);
            await event.applyChangeset({
              constraintType: "assoonaspossible",
              constraintDate: null,
            });
            await AsyncHelper.sleep(200);
            await event.applyChangeset({
              constraintType: null,
              constraintDate: null,
            });
          }
          if (resolution.isRemoveDependencyResolution) {
            const project = me.project;
            await project.dependencyStore.add({
              id: resolution.dependency.id,
              from: -1, // fake tasks
              to: -2, // fake tasks
            });
            await project.dependencyStore.commitAsync();
            await project.commitAsync();
            await AsyncHelper.sleep(200);
            const dep = project.dependencyStore.map((i) => i).find((i) => i.id === resolution.dependency.id);
            dep.remove();
          }
          // if (resolution.isDeactivateDependencyCycleEffectResolution)
        }
        observer.trigger("conflictResolved");

        /*const { selectedResolutions } = me;
        for (const resolution of selectedResolutions) {
          if (resolution.isRemoveDependencyResolution) {
            resolution.dependency.remove();
          }
          // if (resolution.isDeactivateDependencyCycleEffectResolution)
        }*/
      }
    }, 500);
  }
}

export class OurCycleResolutionPopup extends CycleResolutionPopup {
  async onApplyButtonClick() {
    const me = this;

    await super.onApplyButtonClick();
    const interval = setInterval(() => {
      if (!me.schedulingIssue) {
        clearInterval(interval);
        /*{ selectedResolutions } = me;
      for (const resolution of selectedResolutions) {
        if (resolution.isRemoveDependencyCycleEffectResolution) {
          const dependencies = me.getResolutionParameters(resolution);
          for (const dependency of dependencies) {
            await removeDependency(dependency.toJSON());
          }
          location.reload();
          return;
        }
        // if (resolution.isDeactivateDependencyCycleEffectResolution)
      }*/
        observer.trigger("conflictResolved");
      }
    }, 50);
  }
}
